import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import { getDeploymentType } from "src/organization/pages/project/environment/metrics/hooks/useMetricsLinkData";
import { useAppSelector } from "Store/hooks";

const useDisableHttpMetricsForNonUsageBilled = () => {
  const isUsageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);
  const metricsType = useAppSelector(getDeploymentType);
  return metricsType !== "grid" && !isUsageBilling;
};

export default useDisableHttpMetricsForNonUsageBilled;
